import styled from 'styled-components'
import { DEVICE, BLOCK_MARGIN_TOP } from '../../../util/constants'
import { GriddedContentBlock } from '../../styles/Utility.styles'

export const CtaBlock = styled(GriddedContentBlock)`
  position: relative;
  background-color: var(--content-background-light);
  padding: 45px 0 25px;
  font-weight: 300;
  font-size: 2.8rem;
  color: var(--highlight-blue);
  margin-top: 32px;
  margin-bottom: ${({ bottomPaddingAdjustment }) =>
    bottomPaddingAdjustment
      ? bottomPaddingAdjustment
      : `${BLOCK_MARGIN_TOP}px`};

  @media ${DEVICE.tabletL} {
    padding-top: 65px;
    padding-bottom: 35px;
  }
`

export const LeftAlignedCtaBlock = styled(CtaBlock)`
  background-color: white;
  margin-top: 0;
  margin-bottom: 32px;
  padding-top: 0;

  @media ${DEVICE.tabletL} {
    padding-top: 0;
  }
`

export const TextContainer = styled.div`
  grid-column: 2 / 12;
  text-align: center;
`

export const LeftAlignedTextContainer = styled.div`
  grid-column: 2 / 12;
  text-align: left;
  justify-content: flex-start;
`

export const Title = styled.h2`
  font-weight: 400;
  font-size: 2.4rem;
  line-height: 1.375;
  margin-bottom: 18px;
  color: var(--content-background-dark-blue);

  @media ${DEVICE.tabletL} {
    font-size: 2.8rem;
    margin-bottom: 25px;
  }
`

export const Body = styled.div`
  color: var(--content-background-dark-blue);
  font-weight: 400;
  font-size: 1.8rem;

  p {
    line-height: 1.67;
    margin-bottom: 10px;
    color: var(--content-background-dark-blue);

    @media ${DEVICE.tabletL} {
      line-height: 1.65;
      margin-bottom: 18px;
    }
  }

  a {
    color: var(--highlight-blue);
    text-decoration-line: none;

    :hover {
      text-decoration-line: underline;
    }
  }

  ul {
    list-style-type: disc;
  }

  ul,
  ol {
    /* list-style-position: inside; */
    margin-left: 2rem;
    font-size: 1.8rem;
    padding: 0 31px 1rem;

    @media ${DEVICE.tabletL} {
      padding: 0 120px 1rem;
    }
  }

  li {
    padding-bottom: 1rem;
  }
`

export const additionalCtaStyles = `
  justify-content: center;
  @media ${DEVICE.tabletL} {
    p {
      font-size: 1.8rem;
    }
  }
`

export const leftAlignedCtaStyles = `
  justify-content: flex-start;
  @media ${DEVICE.tabletL} {
    p {
      font-size: 1.8rem;
    }
  }
`

export const IconContainer = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
`

export const IconSmallContainer = styled(IconContainer)`
  width: 53px;
  height: 54px;
  top: -26px;

  @media ${DEVICE.tabletL} {
    display: none;
  }
`

export const IconLargeContainer = styled(IconContainer)`
  width: 72px;
  height: 72px;
  top: -36px;
  display: none;

  @media ${DEVICE.tabletL} {
    display: block;
  }
`
